module.exports = __webpack_public_path__ + "assets/img/tcc-select.4b02e08a.png";